// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEntryReviveBody = {
  poolId: string;
  entryId: string;
  requiredPicksOverride?: number | null;
  livesGranted?: number | null;
  teamsToRelease?: string[] | null;
};

export type typeEntryReviveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    entryId: string;
    status: "revived";
    revivesUsedThisRound: number;
    revivesUsedThisContest: number;
    revivesUsedThisSeason: number;
  };
};

export type typeEntryReviveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryReviveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEntryReviveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEntryReviveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: { type: "string", maxLength: 3000, minLength: 1 },
    requiredPicksOverride: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    livesGranted: {
      oneOf: [{ type: "integer" }, { enum: [null] }],
      deprecated: true,
      description:
        "Retired grant size accepted for compatibility and ignored. A new revival always grants one life.",
    },
    teamsToRelease: {
      oneOf: [
        {
          type: "array",
          items: { type: "string", maxLength: 3000, minLength: 1 },
        },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "entryId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEntryRevive(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEntryReviveBody);
  }

  return async function postEntryRevive(
    payload: typeEntryReviveBody,
  ): Promise<typeEntryReviveOutput200 | typeEntryReviveOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEntryRevive" failed before calling the network. #068d86ceca9a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#068d86ceca9a" },
        },
        data: null,
      } as typeEntryReviveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/entry/revive`,
      httpMethod: "POST",
      options,
    })) as typeEntryReviveOutput200 | typeEntryReviveOutput400;
  };
}
